/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUserNotificationSettingRequestNotificationSetting
 */
export interface UpdateUserNotificationSettingRequestNotificationSetting {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserNotificationSettingRequestNotificationSetting
     */
    cartDropReminder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserNotificationSettingRequestNotificationSetting
     */
    couponNotification?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserNotificationSettingRequestNotificationSetting
     */
    productReActivated?: boolean;
}

/**
 * Check if a given object implements the UpdateUserNotificationSettingRequestNotificationSetting interface.
 */
export function instanceOfUpdateUserNotificationSettingRequestNotificationSetting(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateUserNotificationSettingRequestNotificationSettingFromJSON(json: any): UpdateUserNotificationSettingRequestNotificationSetting {
    return UpdateUserNotificationSettingRequestNotificationSettingFromJSONTyped(json, false);
}

export function UpdateUserNotificationSettingRequestNotificationSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserNotificationSettingRequestNotificationSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cartDropReminder': !exists(json, 'cart_drop_reminder') ? undefined : json['cart_drop_reminder'],
        'couponNotification': !exists(json, 'coupon_notification') ? undefined : json['coupon_notification'],
        'productReActivated': !exists(json, 'product_re_activated') ? undefined : json['product_re_activated'],
    };
}

export function UpdateUserNotificationSettingRequestNotificationSettingToJSON(value?: UpdateUserNotificationSettingRequestNotificationSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cart_drop_reminder': value.cartDropReminder,
        'coupon_notification': value.couponNotification,
        'product_re_activated': value.productReActivated,
    };
}

